import Enum from "../../../enum";
import {
    DATA_TYPE,
    COMMUNICATION_FORMAT,
    DATA_FORMAT,
    DOMAIN_MAX_LENGTH,
} from "../../constants";

export const draftSchema = {
    "documentDraft": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "externalId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.EXTERNAL_ID,
            value: "",
        },
        "name": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "description": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.DESCRIPTION,
            value: "",
        },
        "form": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "serverForm": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "tempSaveForm": {
            type: DATA_TYPE.TEXT,
            value: null,
        },
        "status": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentDraftStatus",
            value: Enum.BE_DOCUMENT_DRAFT_STATUS.NONE,
        },
        "enabledDraftEdit": {
            type: DATA_TYPE.BOOLEAN,
            value: false,
        },
        "departmentId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "memberId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "documentTemplateId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
        "updatedDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        }
    },

    "documentDraftHistory": {
        "source": {
            type: DATA_TYPE.ENUM,
            enum: "HistorySource",
            value: null,
        },
        "actorId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "actorName": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.NAME,
            value: "",
        },
        "documentDraftId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "userAgent": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.USER_AGENT,
            value: "",
        },
        "ip": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.IP,
            value: "",
        },
        "reason": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
        "workspaceId": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "createdDate": {
            type: DATA_TYPE.DATE,
            value: null,
            format: DATA_FORMAT.YYYYMMDD_HHmm,
            communication: COMMUNICATION_FORMAT.TIME,
        },
    },

    "documentDraftHistoryDetail": {
        "id": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.ID,
            value: "",
        },
        "action": {
            type: DATA_TYPE.ENUM,
            enum: "DocumentDraftHistoryAction",
            value: null,
        },
        "changes": {
            type: DATA_TYPE.TEXT,
            value: "",
        },
        "message": {
            type: DATA_TYPE.TEXT,
            maxLength: DOMAIN_MAX_LENGTH.MESSAGE,
            value: "",
        },
    }
} as const;
